/**
 * Medical Templates Service
 * API calls for document templates operations
 */

import { API_ENDPOINTS } from '@/constants/api';
import { apiClient, ApiResponse } from './apiClient';

export interface TemplateDTO {
  id: string;
  doctorId: string;
  name: string;
  type: 'prescription' | 'certificate' | 'exam_request' | 'other';
  content: string;
  createdAt: string;
  updatedAt: string;
  lastUsedAt?: string | null;
}

export interface SaveTemplateDTO {
  id?: string;
  name: string;
  type: 'prescription' | 'certificate' | 'exam_request' | 'other';
  content: string;
}

/**
 * List all templates for the authenticated doctor
 */
export async function listTemplates(): Promise<ApiResponse<TemplateDTO[]>> {
  return apiClient.get(API_ENDPOINTS.TEMPLATES.LIST);
}

/**
 * Create or Update a template
 */
export async function saveTemplate(
  data: SaveTemplateDTO,
): Promise<ApiResponse<TemplateDTO>> {
  return apiClient.post(API_ENDPOINTS.TEMPLATES.SAVE, data);
}

/**
 * Delete a template
 */
export async function deleteTemplate(
  id: string,
): Promise<ApiResponse<void>> {
  return apiClient.delete(API_ENDPOINTS.TEMPLATES.DELETE(id));
}
